/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const DownloadData16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 0H2c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1m-1 13H3v-2h10zm0-4H3V7h10zm0-4H3V3h10z"
    />
  </svg>
);

export const __descriptor_DownloadData = {
  name: "DownloadData",
  instances: [{ size: 16, Component: DownloadData16 }],
} as const;
